<template>
  <div>
    <article class="custom-app" id="custom_app">
      <div class="app-top">
        <h3>多种应用类型</h3>
        <span></span>
      </div>
      <span class="app-text">
        支持多种应用定制开发，满足不同行业需求
      </span>
      <div class="app-content clearfix">
        <address class="content-left">
          <div class="top">
            <img src="../../static/images/custom_develop/wulianwang.png" />
            <h3>物联网&智能软硬定制</h3>
          </div>
          <div class="top1">
            <h3>物联网&智能软硬定制</h3>
            <span
              >逻辑思维智能软硬件定制开发已对接众多智能硬件设备项目，实时高效的信息数字化服务，包括农业、医疗、新能源、家居、共享、运动健康等方面
            </span>
          </div>
          <div class="bottom">
            <img src="../../static/images/custom_develop/xiaochengxu.png" />
            <h3>微信小程序定制</h3>
          </div>
          <div class="bottom1">
            <h3>微信小程序定制</h3>
            <span
              >小程序跨平台的属性，使开发和维护成本更低，开发速度更快。无缝对接微信、APP。逻辑思维软件丰富的开发经验，快速打造企业专属小程序
            </span>
          </div>
        </address>
        <address class="content-center">
          <div class="top">
            <img src="../../static/images/custom_develop/app.png" />
            <h3>APP定制</h3>
          </div>
          <div class="top1">
            <h3>APP定制</h3>
            <span
              >专注高端app开发，高效的技术框架，流畅快速的网页体验，自主研发的代码积累，科学管理流程，4大服务保障体系，让您开发无忧。</span
            >
          </div>
          <div class="bottom">
            <img src="../../static/images/7mouth/aidingzhi2.png" />
            <h3>AI方案定制</h3>
          </div>
          <div class="bottom1">
            <h3>AI方案定制</h3>
            <span
              >依托大模型与机器学习技术，为企业提供从需求分析到落地部署的全流程 AI 定制服务，覆盖智能客服、数据预测等场景，助力企业降本增效、实现业务智能化升级。
            </span>
          </div>
        </address>
        <address class="content-right">
          <div class="top">
            <img src="../../static/images/custom_develop/web.png" />
            <h3>Web系统定制</h3>
          </div>
          <div class="top1">
            <h3>Web系统定制</h3>
            <span
              >丰富的系统架构经验，提供高并发、高可靠性、安全性系统解决方案，助力众多企业解决系统瓶颈，快速抢占市场先机</span
            >
          </div>
          <div class="bottom">
            <img src="../../static/images/custom_develop/qiye.png" />
            <h3>企业系统定制</h3>
          </div>
          <div class="bottom1">
            <h3>企业系统定制</h3>
            <span
              >定制属于企业的个性化管理软件，解决销售无计划、进度无把控、客户无管理、信息无反馈、业绩无考核等问题
            </span>
          </div>
        </address>
      </div>
    </article>
    <article class="custom-process">
      <div class="process">
        <div class="process-top">
          <h3>“1+10”核心产品服务体系</h3>
          <span></span>
        </div>
        <span class="process-text">
          完善、规范的开发流程，推动项目科学落地
        </span>
        <div class="process-content clearfix">
          <address class="content-text clearfix">
           <div class="text-top clearfix">
              <h4>AI落地方案咨询</h4>
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time >= 0 && time <= 3 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <img id="img1" :src="imgList[0].img" />
            </div>
            <div class="text-bottom clearfix">
              <img id="img2" :src="imgList[1].img1" />
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 3 && time <= 6 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <h4>需求调研</h4>
            </div>  
            <div class="text-top top-2 clearfix">
              <h4>需求评估</h4>
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 6 && time <= 9 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <img id="img3" :src="imgList[2].img1" />
            </div>
            <div class="text-bottom bottom-2 clearfix">
              <img id="img4" :src="imgList[3].img1" />
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 9 && time <= 12 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <h4>需求分析</h4>
            </div>
            <div class="text-top top-3 clearfix">
              <h4>需求评审</h4>
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 12 && time <= 15 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <img id="img5" :src="imgList[4].img1" />
            </div>
            <div class="text-bottom bottom-3 clearfix">
              <img id="img6" :src="imgList[5].img1" />
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 15 && time <= 18 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <h4>项目设计</h4>
            </div>
            <div class="text-top top-4 clearfix">
              <h4>项目开发</h4>
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 18 && time <= 21 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <img id="img7" :src="imgList[6].img1" />
            </div>
            <div class="text-bottom bottom-4 clearfix">
              <img id="img8" :src="imgList[7].img1" />
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 21 && time <= 24 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <h4>项目反馈</h4>
            </div>
            <div class="text-top top-5 clearfix">
              <h4>项目测试</h4>
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 24 && time <= 27 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <img id="img9" :src="imgList[8].img1" />
            </div>
            <div class="text-bottom bottom-5 clearfix">
              <img id="img10" :src="imgList[9].img1" />
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 27 && time <= 30 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <h4>项目培训</h4>
            </div>
            <div class="text-top top-6 clearfix">
              <h4>项目维护</h4>
              <div class="div-yuan">
                <div
                  class="big-yuan"
                  :class="{ active: time > 30 && time <= 33 }"
                ></div>
                <div class="small-yuan"></div>
              </div>
              <img id="img11" :src="imgList[10].img1" />
            </div> 

          </address>
          <address class="content-bg clearfix"></address>
        </div>
      </div>
    </article>
    <article class="custom-advantage">
      <div class="advantage-top">
        <h3>定制优势</h3>
        <span></span>
      </div>
      <span class="advantage-text">
        一匠科技为您提供高性价比的软件定制化开发服务
      </span>
      <div class="advantage-content clearfix">
        <address v-for="item in itemList" :key="item.id">
          <span>{{ item.title }}</span>
          <img :src="item.img" />
          <h4>
            {{ item.content }}
          </h4>
        </address>
      </div>
    </article>
    <article class="custom-promise">
      <div class="promise-top">
        <h3>我们的承诺</h3>
        <span></span>
      </div>
      <span class="promise-text">
        专属定制永久使用 保障您的信息和数据安全
      </span>
      <div class="promise-content clearfix">
        <address class="content-left">
          <img src="../../static/images/custom_develop/chengnuo.png" />
        </address>
        <address class="content-right">
          <h3>量身定制</h3>
          <h4>
            根据您的业务需求和预算，专业产品经理帮您及进行产品规划，打造您的专属APP
          </h4>
          <h3>私有服务器独立部署</h3>
          <h4>
            根据用户量、并发、计算、存储等情况灵活配置资源，在数据安全、备份等方面有更多选择空间
          </h4>
          <h3>独享私有安全数据库</h3>
          <h4>
            数据库安全、可靠、合规，系统数据完全私有化，降低了敏感信息泄露的可能性
          </h4>
        </address>
      </div>
    </article>
    <home-advisory></home-advisory>
  </div>
</template>
<script>
import HomeAdvisory from "@/components/pc/HomeAdvisory";
export default {
  name: "customCenter",
  data() {
    return {
      time: 1,
      interval: null,
      imgList: [
        {
          id: 1,
          img: require("../../static/images/custom_develop/1a.png"),
          img1: require("../../static/images/custom_develop/1b.png")
        },
        {
          id: 2,
          img: require("../../static/images/custom_develop/2a.png"),
          img1: require("../../static/images/custom_develop/2b.png")
        },
        {
          id: 3,
          img: require("../../static/images/custom_develop/3a.png"),
          img1: require("../../static/images/custom_develop/3b.png")
        },
        {
          id: 4,
          img: require("../../static/images/custom_develop/4a.png"),
          img1: require("../../static/images/custom_develop/4b.png")
        },
        {
          id: 5,
          img: require("../../static/images/custom_develop/5a.png"),
          img1: require("../../static/images/custom_develop/5b.png")
        },
        {
          id: 6,
          img: require("../../static/images/custom_develop/6a.png"),
          img1: require("../../static/images/custom_develop/6b.png")
        },
        {
          id: 7,
          img: require("../../static/images/custom_develop/7a.png"),
          img1: require("../../static/images/custom_develop/7b.png")
        },
        {
          id: 8,
          img: require("../../static/images/custom_develop/8a.png"),
          img1: require("../../static/images/custom_develop/8b.png")
        },
        {
          id: 9,
          img: require("../../static/images/custom_develop/9a.png"),
          img1: require("../../static/images/custom_develop/9b.png")
        },
        {
          id: 10,
          img: require("../../static/images/custom_develop/10a.png"),
          img1: require("../../static/images/custom_develop/10b.png")
        },
        {
          id: 11,
          img: require("../../static/images/custom_develop/11a.png"),
          img1: require("../../static/images/custom_develop/11b.png")
        },
    
      ],
      itemList: [
        {
          id: 0,
          title: "更短开发周期",
          img: require("../../static/images/custom_develop/01.png"),
          content: "依托云计算资源定制开发，避免重复造轮子，极大缩短开发时间。云计算时代，如何能有效缩短开发周期呢？深蓝果实云上开发区别于传统软件开发公司，将特有的云上开发模式，依托成熟云产品，节省传统软件开发的大量底层开发周期， 助力企业软件、APP、小程序、网站建设快速落地，优质交付。"
        },
        {
          id: 1,
          title: "更低开发成本",
          img: require("../../static/images/custom_develop/02.png"),
          content: "节约大量人力成本、服务器成本和运维成本，实现开发运维低成本。云上开发模式，建立专业的云开发团队，实现开发多角色扮演，让云专家为你节省更多区别于传统开发的人力的成本。适用于企业软件开发、APP开发、小程序开发、网站建设等全交付形式的优质开发模式，助力企业实现高效低价开发，优质交付。"
        },
        {
          id: 2,
          title: "更高产品质量",
          img: require("../../static/images/custom_develop/03.png"),
          content: "依托云平台，产品稳定、快速有效开发，实现高产品质量。云上开发模式建立了软件开发企业适用的全周期质量与过程管理，与云产品本身成熟稳定优势相结合。以面向用户的云产品为质量基准，实现多用户共同把握的高质量产品交付， 为企业软件开发、APP开发、小程序开发、网站建设提供可靠的质量保障。"
        },
        {
          id: 3,
          title: "更好安全性能",
          img: require("../../static/images/custom_develop/04.png"),
          content: "众多用户共同把握产品质量，隔绝隐患，安全性能更好。云上开发模式在原有的软件企业开发模式基础上，提供多维度数据保护，全流程技术支持。云产品、云厂商、市场云产品用户的多维性能维护好及反馈，实现更高安全性能的企业软件开发、APP开发、小程序开发、网站建设模式，实现产品的优质交付。"
        },
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
    this.interval = setInterval(() => {
      if (this.time == 3) {
        document.getElementById('img2').src = this.imgList[1].img;
        document.getElementById('img1').src = this.imgList[0].img1;
      } else if (this.time == 6) {
        document.getElementById('img3').src = this.imgList[2].img;
        document.getElementById('img2').src = this.imgList[1].img1;
      } else if (this.time == 9) {
        document.getElementById('img4').src = this.imgList[3].img;
        document.getElementById('img3').src = this.imgList[2].img1;
      } else if (this.time == 12) {
        document.getElementById('img5').src = this.imgList[4].img;
        document.getElementById('img4').src = this.imgList[3].img1;
      } else if (this.time == 15) {
        document.getElementById('img6').src = this.imgList[5].img;
        document.getElementById('img5').src = this.imgList[4].img1;
      } else if (this.time == 18) {
        document.getElementById('img7').src = this.imgList[6].img;
        document.getElementById('img6').src = this.imgList[5].img1;
      } else if (this.time == 21) {
        document.getElementById('img8').src = this.imgList[7].img;
        document.getElementById('img7').src = this.imgList[6].img1;
      } else if (this.time == 24) {
        document.getElementById('img9').src = this.imgList[8].img;
        document.getElementById('img8').src = this.imgList[7].img1;
      } else if (this.time == 27) {
        document.getElementById('img10').src = this.imgList[9].img;
        document.getElementById('img9').src = this.imgList[8].img1;
      } else if (this.time == 30) {
        document.getElementById('img11').src = this.imgList[10].img;
        document.getElementById('img10').src = this.imgList[9].img1;
      } else if (this.time == 33) {
        document.getElementById('img1').src = this.imgList[0].img;
        document.getElementById('img11').src = this.imgList[10].img1;
        this.time = 0;
      } 
      else if (this.time == 36) {
        document.getElementById('img1').src = this.imgList[0].img;
        document.getElementById('img12').src = this.imgList[11].img1;
        this.time = 0;
      }
      this.time++;
    }, 1000)
  })
  },
  methods: {
    mouseover() {//移进显示
      this.show = 0;
    },
    mouseLeave() {//移出不显示
      this.show = 1;
    },
  },
  components: {
    HomeAdvisory,
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}
</script>
<style lang="stylus" scoped>
.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

div {
  color: #333333;
}

h4 {
  font-weight: 400;
}

.custom-app {
  width: 1400px;
  margin: 0 auto;
  margin-top: 80px;
  text-align: center;
  box-sizing: border-box;

  .app-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .app-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .app-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .app-content {
    width: 1400px;
    margin: 0 auto;
    margin-top: 60px;
    box-sizing: border-box;

    address {
      width: 300px;
      height: 600px;
      box-sizing: border-box;
      float: left;
      position: relative;
    }

    .top {
      border-bottom: 1px solid #EEEEEE;
    }

    .top, .bottom {
      height: 300px;
      box-sizing: border-box;
      background-color: white;

      img {
        margin-top: 77px;
        margin-bottom: 40px;
      }

      h3 {
        font-size: 18px;
        font-weight: bold;
        line-height: 28px;
      }
    }

    .top1, .bottom1 {
      opacity: 0;
      position: absolute;
      height: 300px;
      background: #FFFFFF;
      padding-top: 40px;
      box-shadow: 0px 0px 35px 15px rgba(230, 192, 76, 0.1);

      span {
        padding: 0 40px;
        display: block;
        margin-top: 31px;
        font-size: 16px;
        font-weight: 300;
        color: #666666;
        line-height: 28px;
        text-align: justify;
        text-align-last: center;
      }
    }

    .top1 {
      top: 0px;
    }

    .bottom1 {
      top: 300px;
    }


    .top1:hover, .bottom1:hover {
      opacity: 1;
      transition: opacity 1s;
    }

    .content-left {
      margin-left: 249px;
    }

    .content-center {
      border-left: 1px solid #EEEEEE;
      border-right: 1px solid #EEEEEE;
    }
  }
}

.custom-process {
  width: 100%;
  height: 617px;
  margin: 0 auto;
  margin-top: 80px;
  padding-top: 80px;
  text-align: center;
  box-sizing: border-box;
  background-image: url('../../static/images/custom_develop/liuchengtu.png');

  div {
    color: #FFFFFF;
  }

  .process {
    width: 1400px;
    margin: 0 auto;
  }

  .process-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
    margin: 0 auto;
  }

  .process-top span {
    display: block;
    margin: 15px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .process-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .process-content {
    width: 1372px;
    height: 282px;
    margin: 0 auto;
    margin-top: 80px;
    position: relative;

    .content-bg {
      position: absolute;
      top: 60px;
      width: 95%;
      height: 162px;
      z-index: 0;
      background-image: url('../../static/images/custom_develop/quxian.png');
    }

    .content-text {
      margin: 0 auto;
      width: 100%;
      height: 100%;
      position: absolute;
      text-align: center;

      div {
        width: 70px;
        height: 100%;
        box-sizing: border-box;
      }

      h4 {
        opacity: 0.7;
        font-size: 16px;
        line-height: 28px;
      }

      .div-yuan {
        width: 20px;
        height: 20px;

        .big-yuan {
          width: 20px;
          height: 20px;
          position: absolute;
          background: #FFC000;
          opacity: 0.3;
          border-radius: 50%;
          z-index: 2;
        }

        .active {
          animation: hidden 1s infinite;
        }

        @keyframes hidden {
          0% {
            transform: scale(1);
          }

          50% {
            transform: scale(0.5);
          }

          100% {
            transform: scale(1);
          }
        }

        .small-yuan {
          position: absolute;
          width: 10px;
          height: 10px;
          background: #FFFFFF;
          border-radius: 50%;
          z-index: 3;
        }
      }

      .text-top {
        height: 127px;
        margin-left: 8px;
        margin-top: 148px;
        float: left;

        .div-yuan {
          .big-yuan {
            left: 34px;
            top: 183px;
          }

          .small-yuan {
            left: 39px;
            top: 188px;
          }
        }

        img {
          margin-top: 27px;
        }
      }

      .text-bottom {
        height: 127px;
        margin-left: 47px;
        margin-top: 60px;
        float: left;

        .div-yuan {
          .big-yuan {
            left: 150px;
            top: 141px;
          }

          .small-yuan {
            left: 155px;
            top: 146px;
          }
        }

        h4 {
          margin-top: 25px;
        }
      }

      .top-2 {
        margin-left: 45px;
        margin-top: 96px;

        .div-yuan {
          .big-yuan {
            left: 265px;
            top: 130px;
          }

          .small-yuan {
            left: 270px;
            top: 135px;
          }
        }
      }

      .bottom-2 {
        margin-top: 60px;

        .div-yuan {
          .big-yuan {
            left: 382px;
            top: 139px;
          }

          .small-yuan {
            left: 387px;
            top: 144px;
          }
        }

        h4 {
          margin-top: 25px;
        }
      }

      .top-3 {
        margin-left: 45px;
        margin-top: 102px;

        .div-yuan {
          .big-yuan {
            left: 498px;
            top: 142px;
          }

          .small-yuan {
            left: 503px;
            top: 147px;
          }
        }
      }

      .bottom-3 {
        margin-top: 0;

        .div-yuan {
          .big-yuan {
            left: 614px;
            top: 85px;
          }

          .small-yuan {
            left: 619px;
            top: 90px;
          }
        }

        h4 {
          margin-top: 26px;
        }
      }

      .top-4 {
        margin-left: 45px;
        margin-top: 12px;

        .div-yuan {
          .big-yuan {
            left: 729px;
            top: 52px;
          }

          .small-yuan {
            left: 734px;
            top: 57px;
          }
        }
      }

      .bottom-4 {
        margin-top: 0;

        .div-yuan {
          .big-yuan {
            left: 846px;
            top: 82px;
          }

          .small-yuan {
            left: 851px;
            top: 87px;
          }
        }

        h4 {
          margin-top: 26px;
        }
      }

      .top-5 {
        margin-left: 45px;
        margin-top: 90px;

        .div-yuan {
          .big-yuan {
            left: 961px;
            top: 125px;
          }

          .small-yuan {
            left: 966px;
            top: 130px;
          }
        }
      }

      .bottom-5 {
        margin-top: 84px;

        .div-yuan {
          .big-yuan {
            left: 1078px;
            top: 164px;
          }

          .small-yuan {
            left: 1083px;
            top: 169px;
          }
        }

        h4 {
          margin-top: 25px;
        }
      }

      .top-6 {
        margin-left: 45px;
        margin-top: 135px;

        .div-yuan {
          .big-yuan {
            left: 1194px;
            top: 175px;
          }

          .small-yuan {
            left: 1199px;
            top: 180px;
          }
        }
      }

      .bottom-6 {
        margin-top: 69px;

        .div-yuan {
          .big-yuan {
            left: 1310px;
            top: 149px;
          }

          .small-yuan {
            left: 1315px;
            top: 154px;
          }
        }

        h4 {
          margin-top: 25px;
        }
      }
    }
  }
}

.custom-advantage {
  width: 1400px;
  height: 852px;
  margin: 0 auto;
  margin-top: 80px;
  text-align: center;
  box-sizing: border-box;

  .advantage-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .advantage-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .advantage-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .advantage-content {
    margin-top: 60px;

    address {
      width: 688px;
      height: 298px;
      background: #FFFFFF;
      box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
      border-radius: 4px;
      box-sizing: border-box;
      float: left;
      margin-left: 24px;
      margin-bottom: 24px;
      padding: 20px 48px;
      transition: all .5s;

      span {
        display: inline-block;
        float: left;
        font-size: 20px;
        font-weight: bold;
        line-height: 28px;
        margin-top: 76px;
      }

      img {
        float: right;
        margin-top: 27px;
      }

      h4 {
        float: left;
        font-size: 14px;
        line-height: 28px;
        text-align: left;
        margin-top: 17px;
      }
    }

    address:hover {
      box-shadow: 0px 5px 17px 3px rgba(230, 192, 76, 0.15);
      transform: translateY(-10px);
    }

    address:first-child, address:nth-child(3) {
      margin-left: 0px;
    }
  }
}

.custom-promise {
  width: 1400px;
  margin: 0 auto;
  margin-bottom: 132px;
  text-align: center;
  box-sizing: border-box;

  .promise-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .promise-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .promise-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .promise-content {
    margin-top: 60px;

    .content-left {
      float: left;
      margin-left: 59px;
    }

    .content-right {
      float: left;
      margin-left: 98px;
      text-align: left;
      padding-top: 29px;

      h3 {
        font-size: 20px;
        font-weight: bold;
        border-left: 4px solid #FFC000;
        padding-left: 12px;
        line-height: 20px;
      }

      h4 {
        margin-top: 21px;
        margin-bottom: 56px;
        font-size: 16px;
        padding-left: 16px;
        font-weight: 400;
      }

      h4:last-child {
        margin-bottom: 0px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/CustomCenter.vue